import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tags" }
const _hoisted_2 = { class: "popover-tags" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Highlight = _resolveComponent("Highlight")
  const _component_Badge = _resolveComponent("Badge")
  const _component_Popover = _resolveComponent("Popover")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.highlight_tags, (tag, i) => {
      return (_openBlock(), _createBlock(_component_Badge, {
        key: i,
        blue: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_Highlight, {
              text: _ctx.$utils.str.capitalize(tag) ,
              highlight: $props.highlight
            }, null, 8 /* PROPS */, ["text", "highlight"])
          ])
        ]),
        _: 2 /* DYNAMIC */
      }, 1024 /* DYNAMIC_SLOTS */))
    }), 128 /* KEYED_FRAGMENT */)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.visible_tags, (tag, i) => {
      return (_openBlock(), _createBlock(_component_Badge, {
        key: i,
        brand: i === 0,
        indigo: i === 2
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$utils.str.capitalize(tag)), 1 /* TEXT */)
        ]),
        _: 2 /* DYNAMIC */
      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["brand", "indigo"]))
    }), 128 /* KEYED_FRAGMENT */)),
    ($options.hidden_tags.length)
      ? (_openBlock(), _createBlock(_component_Popover, {
          key: 0,
          placement: "top-end",
          teleported: false,
          class: "popover",
          "show-after": 0,
          trigger: "hover",
          offset: 6
        }, {
          reference: _withCtx(() => [
            _createVNode(_component_Badge, {
              class: "pointer",
              gray: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(" +" + _toDisplayString($options.hidden_tags.length), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, _toDisplayString($options.hidden_tags.join(', ')), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true)
  ]))
}